/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const MOTION = {
  'motion-easing-none': 'cubic-bezier(0, 0, 1, 1)',
  'motion-easing-enter': 'cubic-bezier(0.05, 0.2, 0.2, 1)',
  'motion-easing-exit': 'cubic-bezier(0.5, 0.05, 0.7, 0.6)',
  'motion-easing-move': 'cubic-bezier(0.3, 0.1, 0.1, 1)',
  'motion-duration-none': '0ms',
  'motion-duration-fast': '150ms',
  'motion-duration-medium': '250ms',
  'motion-duration-slow': '350ms',
  'motion-duration-xslow': '450ms'
}
